import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudLoaderModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { ModalSidebarModule } from '../../../../shared/components/modal-sidebar/modal-sidebar.module';
import { AppointmentDetailsBodyModule } from '../appointment-details-body/appointment-details-body.module';
import { AppointmentDetailsFooterModule } from '../appointment-details-footer/appointment-details-footer.module';
import { AppointmentDetailsHeaderModule } from '../appointment-details-header/appointment-details-header.module';
import { AppointmentDetailsSidebarComponent } from './appointment-details-sidebar.component';

@NgModule({
	declarations: [AppointmentDetailsSidebarComponent],
	imports: [
		CommonModule,
		ModalSidebarModule,
		TranslateModule.forChild(),
		FreudLoaderModule,
		AppointmentDetailsHeaderModule,
		AppointmentDetailsBodyModule,
		AppointmentDetailsFooterModule,
	],
	exports: [AppointmentDetailsSidebarComponent],
})
export class AppointmentDetailsSidebarModule {}
